//const lodashClonedeep = require("lodash.clonedeep");
import { cloneDeep } from "lodash";

export function cloneObject(obj: any) {
    return cloneDeep(obj);
    //return JSON.parse(JSON.stringify(obj));
}
